/**
 * Whether MainPage has the data it dereferences during render.
 *
 * MainPage -> SectionPage -> ProjectDetails resolves the selected report
 * template with `reportTemplates.find(t => t.id === selectedReportTemplateId)`.
 * If MainPage mounts before that list has loaded, the lookup yields undefined
 * and ProjectDetails throws on `selectedReportTemplate.id`, which unmounts the
 * whole taskpane and leaves a blank pane.
 *
 * Only downloaded reports need this. A normal document reaches MainPage after
 * the user picks a project/template through SelectPage, by which point both
 * lists are loaded — so those short-circuit to ready and are unaffected.
 */
export interface MainDataReadinessInput {
  projects: Array<{ id: string }>;
  reportTemplates: Array<{ id: string }>;
  projectId: string | null;
  templateId: string | null;
  isDownloadedDocument: boolean;
}

export const isMainDataReady = ({
  projects,
  reportTemplates,
  projectId,
  templateId,
  isDownloadedDocument,
}: MainDataReadinessInput): boolean => {
  if (!isDownloadedDocument) return true;
  if (!projectId || !templateId) return false;
  return projects.some((project) => project.id === projectId) && reportTemplates.some((template) => template.id === templateId);
};